import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { Menu } from "./components/Menu";
import { OfficialMenu } from "./components/OfficialMenu";
import { Reviews } from "./components/Reviews";
import { Gallery } from "./components/Gallery";
import { CallSection } from "./components/CallSection";
import { Reservation } from "./components/Reservation";
import { Contact, Footer } from "./components/Contact";
import { CartSheet } from "./components/CartSheet";
import { Marquee } from "./components/Marquee";
import { WhatsAppFab } from "./components/WhatsAppFab";
import { useLenis } from "./hooks/useLenis";
import { useApp } from "./context/AppContext";
import Admin from "./components/Admin";

const Home = () => {
  useLenis();
  const { lang } = useApp();
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee words={["餐廳", "Cocina Asiática", "Ramen", "Sushi", "Wok", "Dim Sum", "手工制作", "Moralzarzal", "Est. 2018"]} speed={70} />
        <About />
        <Menu />
        <Marquee words={["163 recetas", "Fresco cada día", "Recogida −10%", "A domicilio +2€", "美味佳肴", "Sabor auténtico"]} direction="right" speed={80} />
        <OfficialMenu />
        <Reviews />
        <Gallery />
        <CallSection />
        <Reservation />
        <Contact />
      </main>
      <Footer />
      <CartSheet />
      <WhatsAppFab lang={lang} />
    </>
  );
};

function App() {
  return (
    <AppProvider>
      <div className="App bg-[#0A0A0A] min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid #2A2A2A",
              color: "#FDFBF7",
            },
          }}
        />
      </div>
    </AppProvider>
  );
}

export default App;
